import React from 'react';
import ParticleBackground from './components/Particles';
import Home from './components/Hero';
import Navbar from './components/Navbar';
import About from './components/About';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Projects from './components/Projects';
import { Helmet } from 'react-helmet';

import Badges from './components/Badges';

const App = () => {
  return (
    <div className='bg-black min-h-screen'>
      <Navbar />
      <Home />
      <About />
      <Experience  />
      <ParticleBackground />
      <Badges />

    
      <Projects  />

      <Contact />
      {/* <footer className="p-3 text-righ md:text-2xl font-Merriweather font-semibold">
        <h4 className="mb-3">- Santhosh Raminedi</h4>
        
      </footer> */}
    </div>
  );
};

export default App;




